export default "__VITE_ASSET__Cc279Nwe__"